import { getThemeColors } from "../../lib/theme";

interface TabButtonProps {
  active: boolean;
  onClick: () => void;
  isDark: boolean;
  theme: ReturnType<typeof getThemeColors>;
  children: React.ReactNode;
  className?: string;
  "data-testid"?: string;
}

export function TabButton({
  active,
  onClick,
  isDark,
  theme,
  children,
  className = "",
  "data-testid": dataTestId,
}: TabButtonProps) {
  return (
    <button
      onClick={onClick}
      data-testid={dataTestId}
      className={`py-2.5 px-4 rounded-md text-sm font-medium cursor-pointer transition-all duration-200 ${
        active
          ? isDark
            ? "bg-zinc-800 text-white shadow-lg"
            : "bg-white text-gray-900 shadow-sm"
          : theme.textMuted
      } ${className}`}
    >
      {children}
    </button>
  );
}

interface TabGroupProps {
  children: React.ReactNode;
  className?: string;
  theme: ReturnType<typeof getThemeColors>;
}

export function TabGroup({ children, className = "", theme }: TabGroupProps) {
  return (
    <div
      className={`flex items-center gap-1 p-1 rounded-lg ${theme.bgSecondary} ${theme.border} border ${className}`}
    >
      {children}
    </div>
  );
}
